const required = (displayName) => (value) => (
  (!!value) || `${displayName} is Required`
)

export default required
